export const FETCH_CODES_SUCCESS = 'fetchcodesSuccess';
export const UPDATE_ACTIVE_SORT_FIELD_CODES_M = 'updateActiveSortFieldCodesMutation';
export const UPDATE_SEARCH_CODES_M = 'updateSearchCodesMutation';
export const CLEAR_SEARCH_CODES_M = 'clearSearchCodesMutation';
